import AgGridWrapper from "../../../../../../components/AgGridWrapper/AgGridWrapper";
import ActionButtons from "../../../../../../components/ActionButtons";
import { changeStatus, setGrid } from "../../utils/slice";
import columnDefs from "./columnDefs";
import { useState } from "react";
import ConfirmModal from "../../../../../../components/Modals/ConfirmModal";
import { useAppSelector } from "../../../../../../utils/hooks/hooks";

/**
 * Renders a listing component for the Cms module.
 *
 * @param {Object} props - The props object containing the following properties:
 *   - moduleInfo: The information about the module.
 *   - handleViewClick: The function to handle the view click event.
 *   - handleDeleteClick: The function to handle the delete click event.
 *   - handleEditClick: The function to handle the edit click event.
 * @return {JSX.Element} The rendered listing component.
 */
const Listing: React.FC<any> = ({
  moduleInfo,
  handleViewClick,
  handleDeleteClick,
  handleEditClick,
}) => {
  const cms = useAppSelector(state => state.cmsPages);

  const [statusData, setStatusData] = useState<any>();

  /**
   * Renders ActionRenderer component for the ag grid contains the action buttons.
   */
  const ActionRenderer = (props: any) => {
    return (
      <ActionButtons
        data={props}
        view={{
          action: handleViewClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
        }}
        edit={{
          action: handleEditClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_UPDATE`,
        }}
        deleteButton={{
          action: handleDeleteClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DELETE`,
        }}
      />
    );
  };

  return (
    <>
      <ConfirmModal
        titleName={moduleInfo.title}
        data={statusData}
        close={() => setStatusData(null)}
        callApi={changeStatus}
      />
      <AgGridWrapper
        components={{
          ActionRenderer,
        }}
        onGridReadyWithDispatch={setGrid}
        rowData={cms.rowData}
        columnDefs={columnDefs}
        context={{ setStatusData }}
        paginationPageSize={cms.perPage}
        cacheBlockSize={cms.perPage}
      />
    </>
  );
};

export default Listing;
